// import {TrackType} from '~/components/sections';
// import {config} from '~/locals/aigallery/index';
import '~/style/wenxin/index.less';
import BasePage from './basePage';

export default function Index() {
    return (
        <BasePage />
    );
}
